import {
  updateCreatorFilters,
  updateProductFilters,
  updateSortBy,
  updatePagination,
  resetFilters,
  getCreatorsWithFilters,
  getCreatorsWithPagination,
  _setFilterTimeout,
} from "../slices/creator";

export const creatorMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  const filterActions = [
    updateCreatorFilters.type,
    updateProductFilters.type,
    updateSortBy.type,
    resetFilters.type,
  ];

  // Handle pagination updates
  if (action.type === updatePagination.type) {
    const { page } = action.payload;
    store.dispatch(getCreatorsWithPagination(page));
    return result;
  }

  if (filterActions.includes(action.type)) {
    // Debounce the API call to avoid multiple rapid calls
    if (store.getState().creator._filterTimeout) {
      clearTimeout(store.getState().creator._filterTimeout);
    }

    const timeoutId = setTimeout(() => {
      store.dispatch(getCreatorsWithFilters());
    }, 300); // 300ms debounce

    // Store the timeout ID in the state to clear it if needed
    store.dispatch(_setFilterTimeout(timeoutId));
  }

  return result;
};
